<template>
  <input
    type="checkbox"
    v-model="modelValue"
    :disabled="!!$attrs.disabled"
    ref="checkbox"
    class="surface focus:border-secondary focus:ring-secondary focus:border-text! checked:text-secondary checked:bg-secondary checked:border-secondary cursor-pointer rounded-md border leading-none focus:ring-2 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400 disabled:checked:border-gray-300 disabled:checked:bg-gray-300"
    @keydown.enter="onAlternativeInput"
    @keydown.space.prevent="onAlternativeInput"
    @click="onAlternativeInput"
    :class="size === 'small' ? 'size-4' : size === 'medium' ? 'size-5' : 'size-6'"
  />
</template>

<script setup lang="ts">
const modelValue = defineModel<boolean>({ required: true, default: false })

defineProps({
  size: {
    type: String,
    required: false,
    default: "medium",
    validator: (value: string) => {
      return ["small", "medium", "large"].includes(value)
    }
  }
})

const emit = defineEmits<{
  input: [isSelected: boolean]
  selectionClick: [isSelected: boolean, useRange: boolean]
}>()

function onAlternativeInput(event?: Event) {
  const isSelected = !modelValue.value
  modelValue.value = isSelected

  emit("input", isSelected)
  if (event instanceof MouseEvent) {
    emit("selectionClick", isSelected, event.shiftKey)
  }
}
</script>

<style scoped></style>
